import _ from 'lodash';
import {PREFIX, actionMeta} from './meta';
import URLService from 'service/URLService';

const ty = actionMeta.identifiers;

let initState = {
    tenants: null
};

export default function reducer(state = initState, action = "") {

    //console.log("action:", action.type, " payload:", action.payload)

    if (action.type.startsWith(PREFIX)) {
        switch (action.type) {
          case ty.TENANTS_LIST_REQUEST:
            state = {
              ...state,
              tenants: null
            }
            break;
            case ty.TENANTS_LIST_RESPONSE:
                state = {
                    ...state,
                    tenants: action.payload.data.tenants
                }
                break;
            case ty.TENANT_CREATE_RESPONSE:
                state = {
                    ...state,
                    tenants: [
                        ..._.filter(state.tenants, (t) => t.id!=action.payload.data.id),
                        action.payload.data
                    ]
                }
                URLService.setQueryParameter("tenant_id", action.payload.data.id)
                break;
            default:
                return state
                break;
        }
    }

    return state;
}



// WEBPACK FOOTER //
// ./src/storeState/tenants/reducer.js